import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { makeGetTask } from '../selectors/tasks';

import Popout from './popout';
import ProjectName from 'components/project-name';
import TaskSelector from 'components/TaskSelector';
import ProjectSelector from 'components/ProjectSelector';

import IconClose from '../icons/icon-close';
import IconArrowDown from '../icons/icon-arrow-down';

class SelectTaskPopout extends PureComponent {
    state = {
        popoutVisible: false,
        selectingProject: false,
        projectId: this.props.projectId
    }

    handlePopoutOpenClick = () => {
        this.show();
    }

    handlePopoutCloseClick = () => {
        this.popoutCtrl.hide();
    }

    handlePopoutShow = () => {
        this.setState({
            popoutVisible: true
        });
    }

    handlePopoutHide = () => {
        this.setState({
            popoutVisible: false
        });
    }

    handleTaskUntie = () => {
        this.props.onUntie && this.props.onUntie();

        this.popoutCtrl.hide();
    }

    handleTaskSelect = taskId => {
        this.props.onSelect(taskId);

        this.popoutCtrl.hide();
    }

    handleProjectChangeClick = () => {
        this.setState({
            selectingProject: true
        });
    }

    handleProjectSelect = projectId => {
        this.setState({
            projectId,
            selectingProject: false
        });
    }

    show() {
        this.popoutCtrl.show();
    }

    setPopoutCtrl = ctrl => this.popoutCtrl = ctrl;

    render() {
        // TODO: Add content loader
        const children = React.Children.map(this.props.children, child => {
            return React.cloneElement(child, {
                className: child.props.className + (this.state.popoutVisible ? ' selected disable-tooltip' : '')
            });
        });

        return (
            <React.Fragment>
                <div onClick={this.handlePopoutOpenClick}>
                    {children}
                </div>

                <Popout
                    className="no-arrow xxsmall popout-resource-selector"
                    provideController={this.setPopoutCtrl}
                    onShow={this.handlePopoutShow}
                    onHide={this.handlePopoutHide}
                    xAlign={this.props.xAlign}
                    defaultXPosition={this.props.defaultXPosition}
                    closeOnEveryClick={true}
                >
                    <div className="popout-head">
                        {this.props.title}

                        <button className="btn btn-icon btn-small popout-close" onClick={this.handlePopoutCloseClick}>
                            <IconClose />
                        </button>
                    </div>

                    <div className="popout-main">
                        {
                            this.state.selectingProject ? (
                                <ProjectSelector selected={this.state.projectId} onSelect={this.handleProjectSelect} />
                            ) : (
                                <React.Fragment>
                                    <div className="popout-resource-selector-extra">
                                        In Project <strong className="clickable text-colored"onClick={this.handleProjectChangeClick}><ProjectName id={this.state.projectId} /> <IconArrowDown size="14px" /></strong>
                                    </div>

                                    <TaskSelector projectId={this.state.projectId} selected={this.props.selected} onSelect={this.handleTaskSelect} excluded={this.props.excluded} />
                                </React.Fragment>
                            )
                        }

                    </div>

                    {
                        this.props.selected ? (
                            <div className="popout-foot">
                                <span className="action" onClick={this.handleTaskUntie}>Remove Task</span>
                            </div>
                        ) : null
                    }
                </Popout>
            </React.Fragment>
        );
    }
}

const makeMapStateToProps = () => {
    const getTask = makeGetTask();

    return ({ tasks }, ownProps) => ({
        selectedTask: ownProps.selected && getTask(tasks.items, ownProps.selected)
    });
}

export default connect(makeMapStateToProps)(SelectTaskPopout);
